import React from "react";

export default function RecognitionAndReward() {
  return (
    <section className="awards-section p-t-100 p-b-100">
      <div className="container">
        <h2 className="h2 semi-bold text-grey">Recognition & Awards</h2>

        <div className="row">
          <div className="col-4">
            <div className="m-t-60">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/3/editors-choice.webp, https://storage.googleapis.com/programminghub/landing_page/3/editors-choice%402x.webp 2x, https://storage.googleapis.com/programminghub/landing_page/3/editors-choice%403x.webp 3x`}
                />

                <img
                  src={'https://storage.googleapis.com/programminghub/landing_page/4/editors-choice.png'}
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/4/editors-choice%402x.png 2x,
                        https://storage.googleapis.com/programminghub/landing_page/4/editors-choice%403x.png 3x`}
                  className="img-fluid"
                  alt="Editor's Choice"
                />
              </picture>
              <h4 className="h4 text-light-grey m-t-20 light">
                Google Editor’s Choice 2017
              </h4>
            </div>
          </div>
          <div className="col-4">
            <div className="m-t-60">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/5/best-app.webp, https://storage.googleapis.com/programminghub/landing_page/5/best-app%402x.webp 2x, https://storage.googleapis.com/programminghub/landing_page/5/best-app%403x.webp 3x`}
                />

                <img
                  src={'https://storage.googleapis.com/programminghub/landing_page/6/best-app.png'}
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/6/best-app%402x.png 2x,
                        https://storage.googleapis.com/programminghub/landing_page/6/best-app%403x.png 3x`}
                  className="img-fluid"
                  alt="Best App"
                />
              </picture>
              <h4 className="h4 text-light-grey m-t-20 light">
                Google Best App 2017
              </h4>
            </div>
          </div>
          <div className="col-4">
            <div className="m-t-60">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/7/google-launchpad.webp, https://storage.googleapis.com/programminghub/landing_page/7/google-launchpad%402x.webp 2x, https://storage.googleapis.com/programminghub/landing_page/7/google-launchpad%403x.webp 3x`}
                />

                <img
                  src={'https://storage.googleapis.com/programminghub/landing_page/8/google-launchpad.png'}
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/8/google-launchpad%402x.png 2x,
                        https://storage.googleapis.com/programminghub/landing_page/8/google-launchpad%403x.png 3x`}
                  className="img-fluid"
                  alt="Google Launchpad"
                />
              </picture>
              <h4 className="h4 text-light-grey m-t-20 light">
                Google LaunchPad Accelerator
              </h4>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4">
            <div className="m-t-60">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/9/product-hunt.webp, https://storage.googleapis.com/programminghub/landing_page/9/product-hunt%402x.webp 2x, https://storage.googleapis.com/programminghub/landing_page/9/product-hunt%403x.webp 3x`}
                />
                <img
                  src={'https://storage.googleapis.com/programminghub/landing_page/10/product-hunt.png'}
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/10/product-hunt%402x.png 2x,
                        https://storage.googleapis.com/programminghub/landing_page/10/product-hunt%403x.png 3x`}
                  className="img-fluid"
                  alt="Prdocut hunt"
                />
              </picture>
              <h4 className="h4 text-light-grey m-t-20 light">
                Featured on Product Hunt
              </h4>
            </div>
          </div>
          <div className="col-4">
            <div className="m-t-60">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/12/fbstart.webp, https://storage.googleapis.com/programminghub/landing_page/12/fbstart%402x.webp 2x, https://storage.googleapis.com/programminghub/landing_page/12/fbstart%403x.webp 3x`}
                />

                <img
                  src={'https://storage.googleapis.com/programminghub/landing_page/11/fbstart.png'}
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/11/fbstart%402x.png 2x,
                        https://storage.googleapis.com/programminghub/landing_page/11/fbstart%403x.png 3x`}
                  className="img-fluid"
                  alt="Facebook Start"
                />
              </picture>
              <h4 className="h4 text-light-grey m-t-20 light">
                Facebook Award
              </h4>
            </div>
          </div>
          <div className="col-4">
            <div className="m-t-60">
              <picture>
                <source
                  type="image/webp"
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/13/kyoorius.webp, https://storage.googleapis.com/programminghub/landing_page/13/kyoorius%402x.webp 2x, https://storage.googleapis.com/programminghub/landing_page/13/kyoorius%403x.webp 3x`}
                />
                <img
                  src={'https://storage.googleapis.com/programminghub/landing_page/14/kyoorius.png'}
                  srcSet={`https://storage.googleapis.com/programminghub/landing_page/14/kyoorius%402x.png 2x,
                        https://storage.googleapis.com/programminghub/landing_page/14/kyoorius%403x.png 3x`}
                  className="img-fluid"
                  alt="Kyoorius"
                />
              </picture>
              <h4 className="h4 text-light-grey m-t-20 light">
                Kyoorius Digital Award
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
